import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { TypographyWithInfoIcon } from "@rentablo/components";
import { MiniBarChart } from "@components/Chart/MiniBarChart/MiniBarChart";
import { toRoundedNumber } from "@helpers";

interface Props {
  investmentName: string;
  recommendationName: string;
  investmentValue: number;
  recommendationValue: number;
  title: string;
  titleTooltip: string;
  chartLabel: string;
  showSmaller?: boolean;
}

export const BarChartBlock = ({
  investmentName,
  recommendationName,
  investmentValue,
  recommendationValue,
  title,
  titleTooltip,
  chartLabel,
  showSmaller,
}: Props) => {
  const { t } = useTranslation();

  const isInvestmentHigher = investmentValue > recommendationValue;

  const higherValueName =
    (isInvestmentHigher && !showSmaller) || (!isInvestmentHigher && showSmaller)
      ? investmentName
      : recommendationName;

  const percentageDiff = toRoundedNumber(
    Math.abs(investmentValue - recommendationValue)
  );

  return (
    <>
      <TypographyWithInfoIcon
        variant="body3"
        fontWeight={500}
        textAlign="center"
        tooltipTitle={t(titleTooltip)}
        containerSx={{
          mb: 4,
          textAlign: "center",
        }}
      >
        {t(title, {
          name: higherValueName,
          percentage: percentageDiff,
        })}
      </TypographyWithInfoIcon>
      <Box display="flex" justifyContent="center">
        <MiniBarChart
          value1={investmentValue}
          value2={recommendationValue}
          label={chartLabel}
        />
      </Box>
    </>
  );
};
